import React from "react";
import "../styles.css";

const JeopardyCell = ({ value, onClick, disabled }) => (
  <button
    className={`cell${disabled ? " cell--disabled cell--invisible" : ""}`}
    onClick={onClick}
    disabled={disabled}
  >
    <div className="cell-value">
      <span className="cell-amount">{!disabled ? value : ""}</span>
      <span className="cell-points">{!disabled ? "bodů" : ""}</span>
    </div>
  </button>
);

export default JeopardyCell;